import { Card, CardMedia, Typography, Box } from "@mui/material";
import React from "react";

type EmployeeCardProps = {
  name: string;
  position: string;
  description?: string;
  image: string;
};

const EmployeeCard: React.FC<EmployeeCardProps> = ({
  name,
  position,
  description,
  image,
}) => {
  return (
    <Box sx={{ maxWidth: 300, margin: "auto", mt: 2 }}>
      <Card sx={{ overflow: "hidden", textAlign: "center" }}>
        <CardMedia
          component="img"
          loading="lazy"
          height="300"
          image={image}
          alt={name}
          sx={{ objectFit: "cover", objectPosition: "top" }}
        />
        <Box sx={{ padding: 2.5 }}>
          <Typography variant="h6" color="secondary.main">
            {name}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: "primary.main",
              fontWeight: 600,
              mt: 0.5,
            }}
          >
            {position}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mt: 1,
            }}
          >
            {description}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};

export default EmployeeCard;
